/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ApiRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation jwks
   */
  static readonly JwksPath = '/multitenant/{realm}/jwks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jwks()` instead.
   *
   * This method doesn't expect any request body.
   */
  jwks$Response(params: {
    realm: string;
    
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiRestControllerService.JwksPath, 'get');
    if (params) {
      rb.path('realm', params.realm, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jwks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jwks(params: {
    realm: string;
    
  }
): Observable<{
}> {

    return this.jwks$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
